import React from "react";
import { useState } from "react";
import classes from "../../Components/auth/login-form.module.scss";
import { Button, Col, Form, Input, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/UseAuth";
import { renderAlert } from "./../../services/notifications";
import { required } from "./../../services/forms";
import jwtDecode from "jwt-decode";

const LoginForm = () => {
  const [alert, setAlert] = useState();
  let navigate = useNavigate();
  let { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const iniciarSesion = async (values) => {
    setLoading(true);
    try {
      const token = await login(values);
      const decoded = jwtDecode(localStorage.getItem("token"));
      localStorage.setItem("idLoginUser", decoded.id);
      localStorage.setItem("nombreLoginUser", decoded.nombre);
      setLoading(false);
      if (token) {
        navigate("/");
      }
    } catch (error) {
      setAlert({
        type: "warning",
        message: error.response.data.errores[0].detalle,
      });
      setLoading(false);
    }
  };
  const onChangeValues = () => {
    if (alert) {
      setAlert(undefined);
    }
  };

  const [form] = Form.useForm();
  return (
    <Form
      layout="vertical"
      form={form}
      className={classes.form}
      onFinish={iniciarSesion}
    >
      <div className={classes.title}>¡Bienvenido!</div>
      <div className={classes.description}>
        Ingresá tu usuario y tu contraseña para poder continuar.
      </div>
      {alert && renderAlert(alert.type, alert.message)}
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item label="Usuario" name="UserName" rules={[required]}>
            <Input
              placeholder="ingrese nombre de usuario"
              onChange={onChangeValues}
            />
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item label="Contraseña" name="password" rules={[required]}>
            <Input.Password
              placeholder="************"
              onChange={onChangeValues}
            />
          </Form.Item>
        </Col>
      </Row>

      <Button
        type="primary"
        className="block"
        htmlType="submit"
        loading={loading}
      >
        {!loading && "Ingresar"}
      </Button>
    </Form>
  );
};

export default LoginForm;
